/* CEP lookup identifies the destination. Delivery time is the store's fixed estimate. */
(() => {
  'use strict';
  if (customElements.get('salem-delivery-estimate')) return;
  const cache = new Map();
  const digits = value => value.replace(/\D/g, '').slice(0, 8);
  const formatCep = value => value.length > 5 ? value.slice(0, 5) + '-' + value.slice(5) : value;
  class SalemDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.input = this.querySelector('[data-cep-input]');
      this.button = this.querySelector('[data-cep-submit]');
      this.error = this.querySelector('[data-cep-error]');
      this.result = this.querySelector('[data-cep-result]');
      this.destination = this.querySelector('[data-cep-destination]');
      if (!this.input || !this.button || !this.error || !this.result || !this.destination) return;
      this.events = new AbortController();
      this.sequence = 0;
      this.querySelector('[data-cep-fields]').hidden = false;
      const options = { signal: this.events.signal };
      this.button.addEventListener('click', () => this.lookup(), options);
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          if (!this.button.disabled) this.lookup();
        }
      }, options);
      this.input.addEventListener('input', () => {
        this.cancel();
        this.input.value = formatCep(digits(this.input.value));
        this.input.removeAttribute('aria-invalid');
        this.error.hidden = true;
        this.result.hidden = true;
      }, options);
    }
    disconnectedCallback() {
      this.cancel();
      this.events?.abort();
      this.events = null;
    }
    cancel() {
      this.sequence = (this.sequence || 0) + 1;
      this.request?.abort();
      clearTimeout(this.timer);
      this.request = null;
      if (this.button) {
        this.button.disabled = false;
        this.button.textContent = 'Consultar';
      }
      this.removeAttribute('aria-busy');
    }
    showError(message, invalid = false) {
      this.error.textContent = message;
      this.error.hidden = false;
      this.result.hidden = true;
      if (invalid) this.input.setAttribute('aria-invalid', 'true');
    }
    async lookup() {
      this.cancel();
      const cep = digits(this.input.value);
      this.error.hidden = true;
      this.result.hidden = true;
      this.input.removeAttribute('aria-invalid');
      if (cep.length !== 8) {
        this.showError('Informe um CEP com 8 números.', true);
        this.input.focus();
        return;
      }
      this.input.value = formatCep(cep);
      const sequence = this.sequence;
      this.button.disabled = true;
      this.button.textContent = 'Consultando…';
      this.setAttribute('aria-busy', 'true');
      const request = new AbortController();
      this.request = request;
      this.timer = setTimeout(() => request.abort(), 8000);
      try {
        let address = cache.get(cep);
        if (!address) {
          const response = await fetch('https://viacep.com.br/ws/' + cep + '/json/', {
            signal: request.signal,
            credentials: 'omit',
            referrerPolicy: 'no-referrer'
          });
          if (!response.ok) throw new Error('CEP service unavailable');
          address = await response.json();
        }
        if (sequence !== this.sequence || !this.isConnected) return;
        if (address.erro || typeof address.localidade !== 'string' || !/^[A-Z]{2}$/.test(address.uf || '')) {
          this.showError('CEP não encontrado. Confira os números e tente novamente.', true);
          return;
        }
        cache.set(cep, address);
        this.destination.textContent = 'Entrega para ' + address.localidade + ' / ' + address.uf + ' · ' + formatCep(cep);
        this.result.hidden = false;
      } catch (_) {
        if (sequence === this.sequence && this.isConnected) {
          this.showError('Não foi possível consultar o CEP agora. Tente novamente. O prazo padrão da loja é de 7 a 14 dias corridos.');
        }
      } finally {
        if (sequence === this.sequence) {
          clearTimeout(this.timer);
          this.button.disabled = false;
          this.button.textContent = 'Consultar';
          this.removeAttribute('aria-busy');
          this.request = null;
        }
      }
    }
  }
  customElements.define('salem-delivery-estimate', SalemDeliveryEstimate);
})();

